import { render, staticRenderFns } from "./delete-account.vue?vue&type=template&id=5f5d1f34&"
import script from "./delete-account.vue?vue&type=script&lang=js&"
export * from "./delete-account.vue?vue&type=script&lang=js&"
import style0 from "./delete-account.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports